import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UrlServidor } from "../util/url-servidor";
import { Observable } from "rxjs";
import { FolhaPessoaFisica } from "../api/dto/folha-pessoa-fisica";
import { ItemLancamentoFolha } from "../api/dto/item-lancamento-folha";
import { FolhaAgrupada } from "../api/dto/folha-agrupada";

@Injectable({
  providedIn: "root",
})
export class FolhaPessoaFisicaService {
  constructor(private http: HttpClient) { }

  private url: string = UrlServidor.URL_BASE + "folha-pessoa-fisica/";

  listarExtratoPorEmpresa(empresaId?: number, competencia?: Date,
    contratoId?: number, profissionalId?: number): Observable<FolhaAgrupada> {

    let params = new HttpParams();
    if (competencia) {
      params = params.set("competencia", competencia.toISOString());
    }
    if (contratoId) {
      params = params.set("contratoId", contratoId);
    }
    if (profissionalId) {
      params = params.set("profissionalId", profissionalId);
    }

    return this.http.get<FolhaAgrupada>(this.url + "empresa/" + empresaId + "/extrato", { params: params });
  }

  listarItemLancamentoFolha(empresaId?: number, codigoPlanoConta?: number,
    codigoComissao?: number,
    aplicacao?: string,
    competencia?: Date):
    Observable<ItemLancamentoFolha[]> {


    let params = new HttpParams();
    if (codigoPlanoConta) {
      params = params.set('codigoPlanoConta', codigoPlanoConta);
    }
    if (codigoComissao) {
      params = params.set('codigoComissao', codigoComissao);
    }
    if (aplicacao) {
      params = params.set('aplicacao', aplicacao);
    }

    if (competencia) {
      params = params.set('competencia', competencia.toISOString());
    }


    return this.http.get<ItemLancamentoFolha[]>(`${this.url}empresa/${empresaId}/agrupada`, { params });
  }

  salvarLista(listaLancamentos: FolhaPessoaFisica[]): Observable<void> {
    return this.http.post<void>(this.url + "lista", listaLancamentos);
  }

  excluir(id?: number): Observable<void> {

    return this.http.delete<void>(this.url + id);
  }

  finalizarFolha(empresaId?: number, competencia?: Date): Observable<void> {
    return this.http.post<void>(`${this.url}empresa/${empresaId}/competencia/${competencia?.toISOString()}/finalizar`, {});
  }
}
